import {API_GATEWAY} from '../../../utils/constants';
import API_FETCH from '../../../services/api/ApiFetch';

const LoginService = {
    postObtUsuario(pPayload: any) {
        return API_FETCH.post(API_GATEWAY.NAME, '/worksite/tercero/listar', {body: pPayload});
    },
    postGetAsesor(pPayload: any) {
        return API_FETCH.post(API_GATEWAY.NAME, '/worksite/dependencia/asesor', {body: pPayload});
    }
}

export default LoginService;
